export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=6b943620"


//////////////////
// WEBPACK FOOTER
// ./src/components/content/links/create.vue?vue&type=template&id=6b943620
// module id = aRWb
// module chunks = 0